import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppdataService } from '../../../../service/appdata.service';
import { frontendserverurl } from '../../../../../environments/environment';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { CategoryService } from '../../../../service/category.service';
import { StreamOrderItem } from '../../../../interfaces/generic-streams';

@Component({
    selector: 'app-category-item',
    standalone: false,

    templateUrl: './category-item.component.html',
    styleUrl: './category-item.component.scss'
})
export class CategoryItemComponent {
    @Input({ required: true }) category: any;
    @Input({ required: true }) streams: any[] = [];
    @Input({ required: true }) streamOrder: StreamOrderItem[] = [];
    @Output() showCreateCategory = new EventEmitter<any>();
    @Output() editCategory = new EventEmitter<any>();
    @Output() deleteCategory = new EventEmitter<any>();

    frontendurl = frontendserverurl;

    constructor(
        private appdata: AppdataService,
        private categoryService: CategoryService
    ) {
    }

    getColorOfTag = (tag: any) => {
        return (this.appdata.tagGroups as any[]).find(group => group.id === tag.tagGroupId)?.colorClass;
    }


    async drop(event: any) {
        moveItemInArray(this.category.children, event.previousIndex, event.currentIndex);
        let updatedOrders = this.category.children.map((item: any, index: any) => ({
            id: item["id"],
            orderNr: index + 1,
        }));
        this.categoryService.updateOrderNumbers({ orderNumbers: updatedOrders });
    }
}
